import { API_CONFIGURABLES } from "../../utils/apis";
import { getRegister } from "../../utils/helpers";
import { URL_CONFIGURABLES } from "../../utils/urls";

export const useConfigurablesForm = (id?: string | any) => {
  let actualId: string | undefined;

  if (typeof id === "string") {
    actualId = id;
  } else if (id && typeof id === "object") {
    actualId = id.id || id.key || undefined;
  } else {
    actualId = undefined;
  }

  // Now check if we're in edit mode with the actual string id
  const isEdit = Boolean(
    actualId && actualId !== "" && actualId !== "undefined",
  );

  const sections = [
    {
      title: "Configurable Details",
      fields: [
        {
          field_name: "key",
          type: "text",
          label: "Configurable Key",
          props: {
            required: true,
            readOnly: isEdit,
            disabled: isEdit,
          },
        },
        {
          field_name: "name",
          type: "text",
          label: "Configurable Name",
          props: { required: true },
        },
      ],
    },
  ];

  const redirect = getRegister(URL_CONFIGURABLES);
  return {
    sections,
    redirect,
  };
};

export function submitConfigurables(payload: any, id: string) {
  // on update
  if (id) {
    return {
      id,
      api: API_CONFIGURABLES,
      params: { key: payload?.key, name: payload?.name },
    };
  }
  // on create
  return {
    api: API_CONFIGURABLES,
    params: payload,
  };
}
